import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, Redirect } from 'react-router';
import { Button, Col, FormGroup, Label, Row } from 'reactstrap';
import { ISolidsControlEquip } from '../../../../Interfaces/AdminInterface';
import ButtonRow from '../../../ButtonRow';
import { EButton, EInput } from '../../../EInput';



@inject('stores')
@observer
class AdminSolidsControlEquipDetails extends React.Component {

    public props: any;
    public solidsControlEquip: ISolidsControlEquip = new ISolidsControlEquip();
    public solidsControlEquipDisposer: any;
    public adminStore: any;
    public MessageStore: any;
    private UserStore: any;

    public state = {
        isDirty: false,
        redirect: false,
        solidsControlEquip: this.solidsControlEquip,
        solidsControlEquipId: '',
    };

    constructor(props: any) {
        super(props);

        this.adminStore = this.props.stores.AdminStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.UserStore = props.stores.UserStore;
        this.handleChange = this.handleChange.bind(this);
        this.handleSaveSolidsControlEquip = this.handleSaveSolidsControlEquip.bind(this);
        this.removeSolidsControlEquipment = this.removeSolidsControlEquipment.bind(this);
    }

    public componentDidMount() {
        this.createDisposers();

        this.setState({
            solidsControlEquipId: this.props.match.params.id,
        }, () => {
            if ( this.state.solidsControlEquipId !== 'new' ) {
                this.adminStore.getSolidsControlEquip(this.props.match.params.id);
            }
        });
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public createDisposers() {
        this.solidsControlEquipDisposer = intercept(this.adminStore, 'solidsControlEquip', (change: any) => {
            this.setState({
                solidsControlEquip: change.newValue
            });

            return change;
        });
    }

    public clearDisposers() {
        this.solidsControlEquipDisposer();
    }

    public handleChange(event: any) {
        const solidsControlEquip = this.state.solidsControlEquip;

        solidsControlEquip[event.target.name] = event.target.value;

        this.setState({
            isDirty: true,
            solidsControlEquip
        });
    }

    public handleSaveSolidsControlEquip() {
        this.adminStore.saveSolidsControlEquip(this.state.solidsControlEquip)
            .then(
                (data: any) => {
                    this.setState({
                        redirect: true
                    });

                    this.MessageStore.addMessage(
                        'Changes have been saved',
                        'success'
                    );
                },
                (error: any) => {
                    this.MessageStore.addMessage(
                        error.toString(),
                        'danger'
                    );
                }
            );
    }

    public removeSolidsControlEquipment() {
        this.adminStore.deleteSolidsControlEquip(this.state.solidsControlEquip)
            .then(
                (data: any) => {
                    this.setState({
                        redirect: true
                    });

                    this.MessageStore.addMessage(
                        'Solids Control Equipment Successfully Deleted',
                        'success'
                    );
                }
            );
    }

    public render() {
        return(
            this.state.redirect ? (
                <Redirect to="/admin/solidsControlEquips" />
            ) : (
                <div>
                    <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                    <Row>
                        <Col md="6">
                            <FormGroup className="required">
                                <Label>Device Name</Label>
                                <EInput
                                    type="text"
                                    name="deviceName"
                                    required={true}
                                    value={this.state.solidsControlEquip.deviceName}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <ButtonRow>
                        {
                            this.UserStore.hasPermission('Permissions.Admin.SolidEquip.Delete') &&
                            <Button color="danger" onClick={this.removeSolidsControlEquipment} >Delete Solids Control Equipment</Button>
                        }
                        {
                            (this.state.solidsControlEquip.id === '' ?
                            this.UserStore.hasPermission('Permissions.Admin.SolidEquip.Create')
                            :
                            this.UserStore.hasPermission('Permissions.Admin.SolidEquip.Update'))
                            &&
                            <EButton color="primary" onClick={this.handleSaveSolidsControlEquip}>Save Solids Control Equipment</EButton>
                        }
                    </ButtonRow>
                </div>
            )
        );
    }
}

export default AdminSolidsControlEquipDetails;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/SolidsControlEquips/AdminSolidsControlEquipDetails.tsx